import { render, staticRenderFns } from "./ViewJsonFile.vue?vue&type=template&id=78fcc4cb&scoped=true&"
import script from "./ViewJsonFile.vue?vue&type=script&lang=js&"
export * from "./ViewJsonFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fcc4cb",
  null
  
)

export default component.exports